import { datadogLogs } from '@datadog/browser-logs';

export const initDatadog = () => {
    const hostname = window.location.hostname;
    const env = hostname === import.meta.env.VITE_CHARGE_GO_HOSTNAME ? 'prod' : 'test';

    datadogLogs.init({
        clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
        site: import.meta.env.VITE_DATADOG_SITE,
        env,
        service: 'man-charge-go-frontend',
    });
    datadogLogs.setGlobalContextProperty('account_name', 'man-emsp-prod');
    datadogLogs.setGlobalContextProperty('team', 'man-team-emsp');
    datadogLogs.setGlobalContextProperty('account_id', '920885047218');
};
